import { ValidationRules } from "@/models/Validation"

import { t } from "@/plugins/i18n";
export default interface PcCode{
  id: number;
  national: string;
  english: string;
  foreign1: string;
  valueNational: string;
  valueEng: string;
  tablename: string;
  columnName: string;
  pcCode: string;
  pcCodeLen: number;
  inEdit: boolean;
  displayText: string;
  selectedPcCode: PcCode | null;
  pcCode6: string;
  selectedCarCategory: PcCode | null;
  deleted: boolean;
}

export const PcCodeDefaultProps: PcCode = {
  id: 0,
  national: "",
  english: "",
  foreign1: "",
  valueNational: "",
  valueEng: "",
  tablename: "",
  columnName: "",
  pcCode: "",
  pcCodeLen: 0,
  inEdit: false,
  displayText: "",
  selectedPcCode: null,
  pcCode6: "",
  selectedCarCategory: null,
  deleted: false,
}

export const PcCodeValidationRules: ValidationRules = {
  pcCode: [
    (v: string) => !!v || t("Kotelezo"),
    (v: string) => v.replace(/\s+/g, "").length >= 1 || t("Kotelezo"),
    (v: string) => v.length <= 2 || t("PcCode_NemLehetHosszabbKetKarakternel")
  ],
}